/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019-2022 (original work) Open Assessment Technologies SA ;
 */

const localeMappers = new Map([
    [/ar-.{2}/, () => import('flatpickr/dist/esm/l10n/ar.js').then(m => m.Arabic)],
    [/de-AT/, () => import('flatpickr/dist/esm/l10n/at.js').then(m => m.Austria)],
    [/Lt-az-AZ/, () => import('flatpickr/dist/esm/l10n/az.js').then(m => m.Azerbaijan)],
    [/be-BY/, () => import('flatpickr/dist/esm/l10n/be.js').then(m => m.Belarusian)],
    [/bg-BG/, () => import('flatpickr/dist/esm/l10n/bg.js').then(m => m.Bulgarian)],
    [/ca-ES/, () => import('flatpickr/dist/esm/l10n/cat.js').then(m => m.Catalan)],
    [/cs-CZ/, () => import('flatpickr/dist/esm/l10n/cs.js').then(m => m.Czech)],
    [/da-DK/, () => import('flatpickr/dist/esm/l10n/da.js').then(m => m.Danish)],
    [/de-DE/, () => import('flatpickr/dist/esm/l10n/de.js').then(m => m.German)],
    [/es-.{2,3}/, () => import('flatpickr/dist/esm/l10n/es.js').then(m => m.Spanish)],
    [/et-EE/, () => import('flatpickr/dist/esm/l10n/et.js').then(m => m.Estonian)],
    [/en-.*/, () => import('flatpickr/dist/esm/l10n/default.js').then(m => m)],
    [/fi-FI/, () => import('flatpickr/dist/esm/l10n/fi.js').then(m => m.Finnish)],
    [/fr-.{2}/, () => import('flatpickr/dist/esm/l10n/fr.js').then(m => m.French)],
    [/he-IL/, () => import('flatpickr/dist/esm/l10n/he.js').then(m => m.Hebrew)],
    [/hu-HU/, () => import('flatpickr/dist/esm/l10n/hu.js').then(m => m.Hungarian)],
    [/is-IS/, () => import('flatpickr/dist/esm/l10n/is.js').then(m => m.Icelandic)],
    [/it-.{2}/, () => import('flatpickr/dist/esm/l10n/it.js').then(m => m.Italian)],
    [/ja-JP/, () => import('flatpickr/dist/esm/l10n/ja.js').then(m => m.Japanese)],
    [/ko-KR/, () => import('flatpickr/dist/esm/l10n/ko.js').then(m => m.Korean)],
    [/lt-LT/, () => import('flatpickr/dist/esm/l10n/lt.js').then(m => m.Lithuanian)],
    [/nb-NO/, () => import('flatpickr/dist/esm/l10n/no.js').then(m => m.Norwegian)],
    [/nn-NO/, () => import('flatpickr/dist/esm/l10n/nn.js').then(m => m.NorwegianNynorsk)],
    [/pl-PL/, () => import('flatpickr/dist/esm/l10n/pl.js').then(m => m.Polish)],
    [/pt-.{2}/, () => import('flatpickr/dist/esm/l10n/pt.js').then(m => m.Portuguese)],
    [/ro-RO/, () => import('flatpickr/dist/esm/l10n/ro.js').then(m => m.Romanian)],
    [/ru-.{2}/, () => import('flatpickr/dist/esm/l10n/ru.js').then(m => m.Russian)],
    [/Cy-sr-SP/, () => import('flatpickr/dist/esm/l10n/sr-cyr.js').then(m => m.SerbianCyrillic)],
    [/Lt-sr-SP/, () => import('flatpickr/dist/esm/l10n/sr.js').then(m => m.Serbian)],
    [/.*/, () => import('./defaultLocale.js').then(m => m.default)]
]);

/**
 * Get flatpickr locale object
 * @param {string} locale - locale code
 * @returns {Promise|void}
 */
export default function getL10n(locale) {
    for (let localeRegex of localeMappers.keys()) {
        if (localeRegex.test(locale)) {
            return localeMappers.get(localeRegex)();
        }
    }
}
